export default class {
  constructor(store) {
    this.store = store;
    window.addEventListener("message", (event) => {
      switch (event.data.action) {
        case "ISLOWRES":
          this.store.commit("isLowRes", event.data.state);
          break;
        case "CURRENT_URL":
          this.chat.currentUrl(event.data.state);
          break;
        case "RELOAD":
          window.location.reload();
          break;
        case "FINISH":
          if (this.chat) this.chat.sendFinish();
          break;
      }

    });
  }

  susbscribeChat(chat) {
    this.chat = chat;
  }


}
